export default "__VITE_ASSET__zu9akiRd__"